import { useEffect, useRef } from 'react'
import { COPY_STRINGS } from '../../../../constants/translatedCopy'
import { PRE_CHECK_MACHINE_STATES } from '../../constants'
import useStudentPreChecks from '../../useStudentPreChecks'
import { ASR_EVENTS } from '../StudentASRConstants'

const MS_TO_REMIND_TO_SPEAK = 6000 // 6 seconds
const MAX_TEACHER_MODE_TRY_COUNT = 2 // how many times to remind the teacher to test before ending it
const MAX_REMIND_TO_SPEAK_COUNT = 4 // how many times to remind the student before calling teacher

export default function ASRInitialSpeechReminders(props) {

    const {speechProps, teacherMode, openTeacherModal} = props

    const studentPreCheck = useStudentPreChecks({ itemToCheck: PRE_CHECK_MACHINE_STATES.studentASRChecks })

    const remindToSpeakTimer = useRef()
    const remindToSpeakCount = useRef(0)

    useEffect(()=>{

        if(teacherMode && remindToSpeakCount.current <= MAX_TEACHER_MODE_TRY_COUNT){
            startReminderToSpeak()
        }else if(!teacherMode && remindToSpeakCount.current <= MAX_REMIND_TO_SPEAK_COUNT){
            startReminderToSpeak()
        }

        return () => {
            cancelReminderToSpeak()
        }
    }, [remindToSpeakCount.current])

    const startReminderToSpeak = () => {
        cancelReminderToSpeak() // cancel existing one first
        remindToSpeakTimer.current = setTimeout(()=>{
            remindToSpeak()
        }, MS_TO_REMIND_TO_SPEAK)
    }
    const cancelReminderToSpeak = () => {
        clearTimeout(remindToSpeakTimer.current)
    }

    const remindToSpeak = async () => {
        const remindCount = remindToSpeakCount.current
        if(teacherMode){
            studentPreCheck.logEvent(ASR_EVENTS.TEACHER_TEST_PROMPT_SPEECH)
            if(remindCount == 0){
                await speechProps.speakWithPromise({textToSpeak: COPY_STRINGS.student_checks.teacher_mode_asr_reminder_one})
            }else{
                await speechProps.speakWithPromise({textToSpeak: COPY_STRINGS.student_checks.teacher_mode_asr_failure_none_worked_one})
                openTeacherModal()
            }
        }else{
            studentPreCheck.logEvent(ASR_EVENTS.STUDENT_PROMPT_SPEECH)
            if(remindCount == 0){
                await speechProps.speakWithPromise({textToSpeak: COPY_STRINGS.student_checks.student_asr_reminder_one})
            }else if(remindCount == 1){
                await speechProps.speakWithPromise({textToSpeak: COPY_STRINGS.student_checks.student_asr_reminder_two})
            }else if(remindCount == 2){
                await speechProps.speakWithPromise({textToSpeak: COPY_STRINGS.student_checks.student_asr_reminder_three})
            }else{
                await speechProps.speakWithPromise({textToSpeak: COPY_STRINGS.student_checks.student_asr_get_teacher})
                openTeacherModal()
            }
        }
        remindToSpeakCount.current = remindCount + 1
    }

    return null
}
